import { useState } from 'react';

import CustomIcon, { SeturIcon } from '@components/utils/CustomIcon';
import { Row } from '@components/formStyles';

import { IconWrapper, TabMenuItem, TextWrapper } from './TabMenu.styled';

export type TabMenu = {
  id: number;
  key: string;
  text: string;
  icon?: SeturIcon;
  iconRotate?: boolean;
};

export type Color = {
  activeTextColor?: string;
  passiveTextColor?: string;
};

interface ITabMenu {
  onTabChange: (id: number) => void;
  defaultTabId?: number;
  tabs: TabMenu[];
  colors?: Color;
}

const TabMenu = ({ tabs, onTabChange, defaultTabId = 1, colors }: ITabMenu) => {
  const [tabId, setTabId] = useState(defaultTabId);

  const handleTabChange = (id: number) => () => {
    setTabId(id);
    onTabChange(id);
  };

  return (
    <Row>
      {tabs.map((item) => (
        <TabMenuItem
          key={item.id}
          onClick={handleTabChange(item.id)}
          isActive={tabId === item.id ? true : false}
          data-testid={`${item.text.toLowerCase()}-tab-button`}
          colors={colors}
        >
          <Row alignItems='center'>
            {item.icon ? (
              <IconWrapper $rotate={Boolean(item?.iconRotate)}>
                <CustomIcon
                  icon={item.icon}
                  fontSize={20}
                  paletteColor={tabId === item.id ? 'primaryBrand' : 'grey800'}
                />
              </IconWrapper>
            ) : null}
            <TextWrapper>{item.text}</TextWrapper>
          </Row>
        </TabMenuItem>
      ))}
    </Row>
  );
};

export default TabMenu;
